// Added by Sejune Oh on 2019-02-18
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react'
import { Route, Redirect, RouteProps } from 'react-router-dom'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Interface
interface AuthRouterFCProps extends RouteProps {
    redirectPath: string
    isAuthenticated: boolean
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const AuthRouter: FC<AuthRouterFCProps> = ({ isAuthenticated, redirectPath, component, ...others }) => {
    if (isAuthenticated) {
        return <Route {...others} component={component} />
    }

    return <Redirect to={redirectPath} />
}

export default AuthRouter
